import { InjectionToken } from '@angular/core';

import { AssetsProvider } from '@core/assets-logic/tutorial-dialog';
import type { HelpTranslationLinkMapKey } from '@core/help-articles-legacy';

export type TutorialStep = {
  imgUrl?: Promise<string>;
  imgUrl2x?: Promise<string>;
  youtubeVideoId?: string;
  title: string;
  description: string;
  articleLinkKey?: HelpTranslationLinkMapKey;
  isStep0?: boolean;
};

export type TutorialDialogContext =
  | 'multilang_intro'
  | 'referrals_onboarding'
  | 'requisitions_intro'
  | 'requisitions_job';

export const ASSETS_PROVIDER = new InjectionToken<AssetsProvider>('AssetsProvider');
